var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('AppLayout',{on:{"showNavigationDrawer":function($event){_vm.showNagitaionDrawer = true}}},[_c('router-view')],1)],1),(_vm.showNagitaionDrawer)?_c('navigation-drawer',{on:{"close":function($event){_vm.showNagitaionDrawer = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }